import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/ide-device-info.hbs';

    export default Marionette.View.extend({
        template: Handlebars.compile(template),
        initialize: function() {
            this.listenTo(this.model, 'change', this.render);
        },
        ui: {
            unenrolled_tooltips: '.unenrolled-tooltip',
        },
        onRender: function() {
            this.ui.unenrolled_tooltips.tooltip();
        },
        templateContext: function() {
            let devicegroup = this.model.rel.get('devicegroup');
            let unenrolled = 'unenrolled device';
            let show = {
                enrolled: false,
                agent_url: true,
                agent_state: true,
                device_state: true,
                agent: true,
            };

            let agent_state = '';

            if (!this.model.get('agent_id') &&
                (devicegroup && devicegroup.type  === 'pre_production_devicegroup')) {
                show.unenrolled = true;
                show.agent_url= false;
                show.agent_state = false;
            } else {
                agent_state =
                    this.model.get('agent_running')
                    ? 'online'
                    : 'offline';
            }

            if (this.model.get('is_dut')) {
                show.agent_url = false;
                show.agent_state = false;
                show.device_state = false;
                show.agent = false;
            }

            let device_state  = this.model.get('device_online') ? 'online' : 'offline';

            return {
                agent_state: agent_state,
                device_state: device_state,
                unenrolled: unenrolled,
                show: show
            };
        }
    });

